export default "__VITE_PUBLIC_ASSET__92fd75b7__"